import { render } from "./AppSeparator.vue?vue&type=template&id=478a6b56"
const script = {}

import exportComponent from "/Users/davecalleja/experiments/playnova-beta/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__